<template>
  <div id="AddressInfo">
    <!--Title-->
    <div class="row">
      <h4 class="col-xs-12 card-title csp-card-title">Address Information</h4>
    </div>
    <!--Text-->
    <div class="row">
      <div class="col-xs-12 ">
        <p class="card-text csp-banner-text">Go ahead and make any changes you need!</p>
      </div>                
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <form>
          
          <div class="md-form">
            <input class="form-control" required type="text" id="csp_address_line1" name="address-line1" autocomplete="address-line1" v-model="line1">
            <label for="csp_address_line1" v-bind:class="{ active: line1 }">Address Line 1</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" required type="text" id="csp_address_line2" name="address-line2" autocomplete="address-line2" v-model="line2">
            <label for="csp_address_line2" v-bind:class="{ active: line2 }">Address Line 2</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" required type="text" id="csp_city" name="address-level2" autocomplete="address-level2" v-model="city">
            <label for="csp_city" v-bind:class="{ active: city }">City</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" required type="text" id="csp_state" name="address-level1" autocomplete="address-level1" v-model="state">
            <label for="csp_state" v-bind:class="{ active: state }">State</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" type="text" id="csp_zip" name="postal-code" autocomplete="postal-code" :value="zip" @maskinput="updateZip" v-mask="{ mask: zipMask, jitMasking: true, placeholder: ' '}">
            <label for="csp_zip" v-bind:class="{ active: zip }">Zip Code</label>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import mask from '../directives/MaskedInput'

  export default {
    name: 'AddressInfo',
    directives: {
      mask
    },
    methods: {
      updateZip: function (value) {
        this.zip = value
      }
    },
    computed: {
      line1: {
        get: function () {
          return this.$store.getters.address.line1
        },
        set: function (newValue) {
          this.$store.commit('updateAddress1', newValue)
        }
      },
      line2: {
        get: function () {
          return this.$store.getters.address.line2
        },
        set: function (newValue) {
          this.$store.commit('updateAddress2', newValue)
        }
      },
      city: {
        get: function () {
          return this.$store.getters.address.city
        },
        set: function (newValue) {
          this.$store.commit('updateCity', newValue)
        }
      },
      state: {
        get: function () {
          return this.$store.getters.address.state
        },
        set: function (newValue) {
          this.$store.commit('updateState', newValue)
        }
      },
      zip: {
        get: function () {
          return this.$store.getters.address.zip
        },
        set: function (newValue) {
          this.$store.commit('updateZip', newValue)
        }
      },
      ...mapGetters([
        'line1Valid',
        'line2Valid',
        'cityValid',
        'stateValid',
        'zipValid',
        'addressInputValid',
        'zipMask'
      ])
    }
  }
</script>

<style scoped>


  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// AddressInfo.vue?bc13d584